import React, {Suspense, useEffect} from 'react';
import {BrowserRouter, Routes, Route, useLocation} from 'react-router-dom';
import HomePage from './Views/HomePage';
import TeamPage from './Views/Team';
import LeistungenPage from './Views/Leistungen';
import GaleriePage from './Views/Galerie';
import ContactPage from './Views/ContactPage';
import NotFound from './Views/NotFound';
import Datenschutz from './Views/Datenschutz';
import Impressum from './Views/Impressum';
import ServiceDetail from './Views/ServiceDetail';
import serviceDetails from './Views/serviceDetails';
import Pflegekosten from './Views/Pflegekosten';
import Faq from './Views/Faq';

// Der Admin-Bereich (inkl. Firebase Auth) wird nur geladen, wenn /admin aufgerufen wird.
const AdminInbox = React.lazy(() => import('./Views/AdminInbox'));

const ScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.scrollTo !== 'function') return undefined;
    const {hash, state, pathname} = location;
    const scrollTarget = state && state.scrollTo ? `#${state.scrollTo}` : hash;

    const safeScrollTo = (options) => {
      try {
        window.scrollTo(options);
      } catch (error) {
        if (process.env.NODE_ENV !== 'test') throw error;
      }
    };

    if (!scrollTarget) {
      safeScrollTo({top: 0, behavior: 'auto'});
      return undefined;
    }

    const scroll = () => {
      const element = document.querySelector(scrollTarget);
      if (!element) return;
      try {
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
      } catch (error) {
        if (process.env.NODE_ENV !== 'test') throw error;
        element.scrollIntoView();
      }
    };

    if (pathname === '/' && document.readyState !== 'complete') {
      window.addEventListener('load', scroll, {once: true});
      return () => window.removeEventListener('load', scroll);
    }

    const timeout = window.setTimeout(scroll, 60);
    return () => window.clearTimeout(timeout);
  }, [location]);

  return null;
};

const AppRouter = () => (
  <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
    <ScrollHandler />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/leistungen" element={<LeistungenPage />} />

      {Object.keys(serviceDetails).map((serviceKey) => (
        <Route
          key={serviceKey}
          path={`/leistungen/${serviceKey}`}
          element={<ServiceDetail serviceKey={serviceKey} />}
        />
      ))}

      <Route path="/pflegekosten" element={<Pflegekosten />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/galerie" element={<GaleriePage />} />
      <Route path="/kontakt" element={<ContactPage />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/impressum" element={<Impressum />} />

      <Route
        path="/admin"
        element={(
          <Suspense fallback={<div className="page" aria-busy="true" />}>
            <AdminInbox />
          </Suspense>
        )}
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default AppRouter;
